import "../styles/account.scss";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Path, AccountTabs } from "../utilities/constants";
import { TabItem } from "../components/tab-item";
import Card from "../components/card";
import PageLayout from "../components/page-layout";
import navigate from "../utilities/navigation";
import AccountGeneral from "./account/AccountGeneral";
import AccountMessaging from "./account/AccountMessaging";
import AccountPermissions from "./account/AccountPermissions";
import AccountPlanUsage from "./account/AccountPlanUsage";
import AccountAlertCategories from "./account/AccountAlertCategories";
import AccountImports from "./account/AccountImports";
import actions from "../actions/actions";
import { useOnFirstLoad } from "../utilities/hooks";

export default function AccountPage() {
  const route = useSelector(
    (store) => store.router.location?.pathname,
  )?.toLowerCase();

  const [accountDetails, setAccountDetails] = useState(null);

  function loadAccountDetails() {
    actions.account.getAccountDetails().then((result) => {
      if (result) setAccountDetails(result);
    });
  }

  useOnFirstLoad(loadAccountDetails);

  const [tabs, content] = useMemo(() => {
    const contentMap = {
      [Path.AccountGeneral]: (
        <AccountGeneral
          generalData={accountDetails?.accountGeneralResponse}
          onSave={loadAccountDetails}
        />
      ),
      [Path.AccountMessaging]: (
        <AccountMessaging
          messagingData={accountDetails?.accountMessagingResponse}
          onSave={loadAccountDetails}
        />
      ),
      [Path.AccountPermissions]: <AccountPermissions />,
      [Path.AccountPlanUsage]: (
        <AccountPlanUsage
          planUsageData={accountDetails?.accountSummaryResponse}
          onSave={loadAccountDetails}
        />
      ),
      [Path.AccountAlertCategories]: (
        <AccountAlertCategories
          accountAlertCategories={accountDetails?.alertCategoryResponse}
          onSave={loadAccountDetails}
        />
      ),
      [Path.AccountImports]: (
        <AccountImports summaryData={accountDetails?.accountSummaryResponse} />
      ),
    };

    const current =
      AccountTabs.find((x) => route.startsWith(x.path)) || AccountTabs[0];

    return [
      AccountTabs.map((x, i) => (
        <TabItem
          tab={x.path}
          currentTab={current.path}
          onClick={navigate}
          key={i}
        >
          {x.title}
        </TabItem>
      )),
      contentMap[current.path],
    ];
  }, [route, accountDetails]);

  return (
    <PageLayout title="Account" className="account-wrapper" tabs={tabs}>
      <Card>{content}</Card>
    </PageLayout>
  );
}
